import { FolderStatusHistoryWidgetStore } from './folder-status-history-widget.store';
import { Component, effect, inject } from '@angular/core';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { routeParams } from '../../../../modules/shared/shared.global-service';
import { personStatusColor } from '../../../../../../../types/src/services/enum/folder-status.enum';
import { featureOn } from '../../../../feature-flag';
import { ButtonComponent } from '../../../kit/button/button.component';
import { TagComponent } from '../../../kit/tag/tag.component';
import { folderStatusHistoryFrag } from './folder-status-history-widget.query';
import { ShortDatePipe } from '../../../../modules/shared/pipes/short-date.pipe';
import { EmptyStateComponent } from '../../../../modules/shared/components/empty-state/empty-state.component';

@Component({
    selector: 'app-folder-status-history-widget',
    templateUrl: './folder-status-history-widget.component.html',
    styleUrl: './folder-status-history-widget.component.scss',
    providers: [FolderStatusHistoryWidgetStore],
    imports: [
        ButtonComponent,
        TagComponent,
        ShortDatePipe,
        EmptyStateComponent,
    ],
})
export class FolderStatusHistoryWidgetComponent {

    public readonly store = inject(FolderStatusHistoryWidgetStore);

    constructor() {
        this.store.onSuccess(() => {
                this.getStatuses();
            },
            'createFolderSocialAcquireProcess',
            'updateFolderSocialAcquireProcess',
            'updateWaitingListItem',
            'terminateFolder',
        );

        effect(() => {
            this.getStatuses();
        });
    }

    private async getStatuses(): Promise<void> {
        await this.store.api.getFolderStatuses(FilterBuilder.filter({
            folderId: routeParams.folderId(),
            limit: 20,
        }), folderStatusHistoryFrag);
    }

    protected readonly featureOn = featureOn;
    protected readonly personStatusColor = personStatusColor;
}
